/**
 * Text-to-speech providers a Twilio voice deployment can name.
 */

import { z } from "zod";

export const TTS_PROVIDERS = ["openai", "elevenlabs", "cartesia", "playht", "rime"] as const;
export const TtsProviderSchema = z.enum(TTS_PROVIDERS);
export type TtsProvider = z.infer<typeof TtsProviderSchema>;
